import React, { useState, useRef, useEffect } from 'react';
import './CountrySearchBar.css';

function CountrySearchBar({ countries, onSearch, onClear }) {
  const [searchQuery, setSearchQuery] = useState('');
  const searchInputRef = useRef(null);

  // Filter countries based on search query and trigger search immediately
  useEffect(() => {
    if (searchQuery.trim() === '') {
      onClear();
      return;
    }

    const query = searchQuery.toLowerCase();
    const matches = countries.filter(country =>
      country.name.toLowerCase().includes(query) ||
      country.code.toLowerCase().includes(query)
    );

    // Trigger filtering immediately as user types
    if (matches.length > 0) {
      // Filter by all matching countries (show routes that match any of them)
      onSearch({ matches, query });
    } else {
      // No matches - show no results
      onSearch({ matches: [], query });
    }
  }, [searchQuery, countries, onSearch, onClear]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
  };

  const handleClearClick = () => {
    setSearchQuery('');
    onClear();
  };

  return (
    <div className="country-search-container">
      <div className="search-input-wrapper">
        <svg
          className="search-icon"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
          <path d="M16 16L21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>

        <input
          ref={searchInputRef}
          type="text"
          className="country-search-input"
          placeholder="Search routes..."
          value={searchQuery}
          onChange={handleSearchChange}
        />

        {searchQuery && (
          <button
            className="clear-search-button"
            onClick={handleClearClick}
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}

export default CountrySearchBar;
